import request from '@/request'
let getData = {
    get_pic: function (data, callback) {
        request.get('car/get_pic', data, callback)
    },
}
export default getData
